import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-pcomp-ag-radial-column-series-options',
	templateUrl:'./AgRadialColumnSeriesPluginCompPage.html',
	styles: [],
	styleUrls:['./AgRadialColumnSeriesPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class AgRadialColumnSeriesPluginCompPage
{
	mdContent_751 = `\`\`\`java
import com.jwebmp.plugins.agchartsenterprise.options.series.AgRadialColumnSeriesOptions;
\`\`\``;
}
